import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Tab, Tabs } from '@mui/material';
import { adminPath, AppView, VIEW_PATHS } from '../routing/appRoutes';
import { ignorePlainClick } from '../routing/linkClick';

type HeaderNavTabsProps = {
  currentView: AppView | null;
  showAdmin: boolean;
};

/**
 * Header view tabs (Home, and Admin when permitted). Each tab is a real <a href> (router link), so
 * Cmd/Ctrl/middle-click opens a new tab and "Copy link" works; the selected tab follows the URL.
 * No Tabs onChange on purpose: it would also fire on modified clicks and navigate the current tab.
 */
export const HeaderNavTabs = ({ currentView, showAdmin }: HeaderNavTabsProps) => {
  const value = currentView === 'admin' && showAdmin ? 'admin' : false;
  return (
    <Tabs
      value={value}
      aria-label="Main navigation"
      variant="scrollable"
      scrollButtons="auto"
      allowScrollButtonsMobile
      sx={{
        minHeight: '48px',
        maxWidth: '100%',
        '& .MuiTab-root': {
          color: '#aaa',
          minHeight: '48px',
          flexShrink: 0,
          whiteSpace: 'nowrap',
          textTransform: 'uppercase',
          fontSize: '0.875rem',
          px: 2,
          '&.Mui-selected': {
            color: '#667eea',
          },
        },
        '& .MuiTabs-indicator': {
          backgroundColor: '#667eea',
        },
      }}
    >
      <Tab label="Home" value="home" component={RouterLink} to={VIEW_PATHS.home} />
      {showAdmin && (
        <Tab
          label="Admin"
          value="admin"
          component={RouterLink}
          to={adminPath()}
          onClick={value === 'admin' ? ignorePlainClick : undefined}
        />
      )}
    </Tabs>
  );
};
